import axios from 'axios';
import { call } from 'redux-saga/effects';
import { getTokenHeaders as tokenHeader } from '../helpers/api.helper';
import { CREATE_ORDER_ENDPOINT, PAY_ORDER_ENDPOINT, UPDATE_ORDER_ENDPOINT, GET_ORDERS_LIST_ENDPOINT, GET_ORDER_DETAILS_ENDPOINT } from '../config/apiEndpoints';

export function* createOrder(payload) {
    const header = tokenHeader();

    return yield call(axios.post, CREATE_ORDER_ENDPOINT, payload, header);
}

export function* payOrder(payload) {
    const header = tokenHeader();
    const URL = PAY_ORDER_ENDPOINT + payload.orderId + '?_format=json';
    return yield call(axios.patch, URL, payload, header);
}

export function* redirectToMobilPay(payload){
    return yield call(axios.post, payload.payment_url, {env_key: payload.env_key, data: payload.data});
}

export function* getOrderDetails(payload) {
    const header = tokenHeader();
    const URL = GET_ORDER_DETAILS_ENDPOINT + payload + '?_format=api_json';
    return yield call(axios.get, URL, header);
}

export function* getOrdersList(payload) {
    const header = tokenHeader();
    const id_user = localStorage.getItem("user_id");
    const URL = GET_ORDERS_LIST_ENDPOINT + id_user + '?format=api_json&items_per_page=All&order_status_value[]=3&order_status_value[]=4&order_status_value[]=5';
    return yield call(axios.get, URL, header);
}

export function* updateOrder(payload) {
    const header = tokenHeader();
    const URL = UPDATE_ORDER_ENDPOINT + payload + '?format=api_json';
    return yield call(axios.patch, URL, payload, header);
}


// WEBPACK FOOTER //
// ./src/SHARED/api/payment.api.js